import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M317.866667 533.333333l185.6 185.6c4.266667 4.266667 10.666667 4.266667 17.066666 0l185.6-185.6c6.4-6.4 2.133333-19.2-8.533333-19.2H554.666667v-170.666666c0-23.466667-19.2-42.666667-42.666667-42.666667s-42.666667 19.2-42.666667 42.666667v170.666666h-142.933333c-10.666667 0-14.933333 12.8-8.533333 19.2z\" p-id=\"20085\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-down.svg
// module id = Peom
// module chunks = 58